/* eslint-disable */
import { rootApi } from '../rootApi';

/**
 * Dinamik N-adımlı onay akışı endpoint'leri (Inbox + Detay + Onayla/Reddet/İade).
 * Yetki kararının son mercii backend'dir (yetkisiz istekte DEALER_APPROVAL_STEP_UNAUTHORIZED).
 */
export const dealerApprovalApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        // Kullanıcının rollerine göre kendi adımı bekleyen Pending talepleri döner.
        getDealerApprovalInbox: builder.query({
            query: ({ PageNumber = 1, PageSize = 10, LanguageId = 2 } = {}) => ({
                url: 'v1/DealerApproval/Inbox',
                method: 'GET',
                params: { PageNumber, PageSize, LanguageId }
            }),
            transformResponse: (response) => {
                if (response?.data) {
                    return { items: response.data.items || [], totalCount: response.data.totalCount ?? 0 };
                }
                return { items: [], totalCount: 0 };
            },
            providesTags: ['DealerApproval']
        }),

        // Onay detayı: adımlar + değişiklik kalemleri (payload + değişen alanlar) + aksiyon günlüğü.
        // NOT: dealerAddressBrandId yalnızca cache tag'i için taşınır (request'e gitmez).
        // Sekme mutation'ları anchor tag { type:'DealerApproval', id } yerine
        // { type:'DealerRegistration', id: dealerAddressBrandId } üzerinden hedefli
        // invalidation yapabilsin diye bu sorgu ek olarak anchor DealerRegistration tag'i sağlar.
        getDealerApprovalById: builder.query({
            query: ({ id, languageId = 2 }) => ({
                url: 'v1/DealerApproval/GetById',
                method: 'GET',
                params: { id, languageId }
            }),
            transformResponse: (response) => (response?.data ? response.data : {}),
            providesTags: (result, error, arg) => {
                const tags = [{ type: 'DealerApproval', id: arg?.id }];
                if (arg?.dealerAddressBrandId != null) {
                    tags.push({ type: 'DealerRegistration', id: arg.dealerAddressBrandId });
                }
                return tags;
            }
        }),

        // Satır geçmişi: targetType + rowId ile kronolojik live/snapshot/shadow kayıtları.
        getDealerApprovalRowHistory: builder.query({
            query: ({ targetType, rowId, languageId = 2 }) => ({
                url: 'v1/DealerApproval/GetRowHistory',
                method: 'GET',
                params: { targetType, rowId, languageId }
            }),
            transformResponse: (response) => (response?.data ? response.data : { items: [] }),
            providesTags: ['DealerApproval']
        }),

        approveDealerApproval: builder.mutation({
            query: ({ approvalId, note, languageId }) => ({
                url: 'v1/DealerApproval/Approve',
                method: 'POST',
                body: { approvalId, note, languageId }
            }),
            transformResponse: (response) => response,
            invalidatesTags: ['DealerApproval', 'DealerRegistration']
        }),

        rejectDealerApproval: builder.mutation({
            query: ({ approvalId, reason, languageId }) => ({
                url: 'v1/DealerApproval/Reject',
                method: 'POST',
                body: { approvalId, reason, languageId }
            }),
            transformResponse: (response) => response,
            invalidatesTags: ['DealerApproval', 'DealerRegistration']
        }),

        returnDealerApproval: builder.mutation({
            query: ({ approvalId, note, languageId }) => ({
                url: 'v1/DealerApproval/Return',
                method: 'POST',
                body: { approvalId, note, languageId }
            }),
            transformResponse: (response) => response,
            invalidatesTags: ['DealerApproval', 'DealerRegistration']
        })
    })
});

export const {
    useGetDealerApprovalInboxQuery,
    useLazyGetDealerApprovalInboxQuery,
    useGetDealerApprovalByIdQuery,
    useLazyGetDealerApprovalByIdQuery,
    useGetDealerApprovalRowHistoryQuery,
    useApproveDealerApprovalMutation,
    useRejectDealerApprovalMutation,
    useReturnDealerApprovalMutation
} = dealerApprovalApi;
